import { format } from 'date-fns';
import parseISO from 'date-fns/parseISO';

export function formatValueForDatetimeLocalInputField(date) {
    return format(parseISO(date),'yyyy-MM-dd\'T\'HH:mm');
    //return new Date(date).toISOString().substring(0,new Date(date).toISOString().length-1)
}